/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = freeGlobal;
